import axios from 'axios';

export default {
  selectors: (params = {}, config = {}) => axios.get('people/selectors', { params, ...config }),
};
